import _ from 'lodash';

import { AI_RESULTS_DELIVERY_PROVIDER_OPTIONS } from 'constants/loanActionEditor';

// The Integration Studio provider list is gated on integrations.view; when it is not loaded every
// delivery-capable connector is offered, and a saved key the list does not hold stays selectable.
export const getDeliveryConnectorOptions = ({ providers, providerKey }) => {
  const configuredOptions = _.isEmpty(providers)
    ? AI_RESULTS_DELIVERY_PROVIDER_OPTIONS
    : AI_RESULTS_DELIVERY_PROVIDER_OPTIONS.filter(({ value }) =>
        providers.some(({ key }) => key === value),
      );
  const isUnlistedProviderKey =
    !_.isNil(providerKey) && !configuredOptions.some(({ value }) => value === providerKey);

  return isUnlistedProviderKey
    ? [...configuredOptions, { name: providerKey, value: providerKey }]
    : configuredOptions;
};
